import React from 'react';
import './style.scss';
import { NavLink } from 'react-router-dom';
import { ProductData } from 'views/components/atoms/productData';
import { ProductInfoProps } from 'views/components/pages/home/hooks';
import { formatDateSlashToJapanese } from 'views/utils/format/FormatDate';

// List表示用
export const ListProductCard = (props: ProductInfoProps) => {
  const { to, image, title, TradeStartDate, TradeEndDate, description, details } = props;
  return (
    <NavLink to={to ? to : ''} className="listProductWrapper">
      <div className="listProductImage">
        <img src={image} />
      </div>
      <div className="listProductInfo">
        <span className="listProductInfo_title">{title}</span>
        <div className="listProductInfo_recruitment">
          募集期間：{formatDateSlashToJapanese(TradeStartDate)}〜{formatDateSlashToJapanese(TradeEndDate)}
        </div>
        <span className="listProductInfo_detail">{description}</span>
        <div className="listProductInfo_data">
          {details.map((detail, i) => (
            <ProductData key={i} {...detail} />
          ))}
        </div>
      </div>
    </NavLink>
  );
};

// 詳細表示用
export const ProductCard = (props: ProductInfoProps) => {
  const { image, title, TradeStartDate, TradeEndDate, description, details } = props;
  return (
    <div className="productWrapper">
      <div className="productImage">
        <img src={image} />
      </div>
      <div className="productInfo">
        <span className="productInfo_title">{title}</span>
        <div className="productInfo_recruitment">
          募集期間：{formatDateSlashToJapanese(TradeStartDate)}〜{formatDateSlashToJapanese(TradeEndDate)}
        </div>
        <span className="productInfo_detail">{description}</span>
        <div className="productInfo_data">
          {details.map((detail, i) => (
            <ProductData key={i} {...detail} />
          ))}
        </div>
      </div>
    </div>
  );
};
